
import Framework7, { Device, Request, Utils } from 'framework7';
import Accordion from 'framework7/components/accordion/accordion.js';
import Form from 'framework7/components/form/form.js';
import Input from 'framework7/components/input/input.js';
import Panel from 'framework7/components/panel/panel.js';
import Popup from 'framework7/components/popup/popup.js';
import Radio from 'framework7/components/radio/radio.js';
import Searchbar from 'framework7/components/searchbar/searchbar.js';
import Sheet from 'framework7/components/sheet/sheet.js';
import SmartSelect from 'framework7/components/smart-select/smart-select.js';
import Tabs from 'framework7/components/tabs/tabs.js';
import Toggle from 'framework7/components/toggle/toggle.js';
import Typography from 'framework7/components/typography/typography.js';

Framework7.use([
  Accordion,
  Form,
  Input,
  Panel,
  Popup,
  Radio,
  Searchbar,
  Sheet,
  SmartSelect,
  Tabs,
  Toggle,
  Typography
]);

export default Framework7;
export { Device, Request, Utils };
